import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "src/store";

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import { languages } from "/src/i18n/index.js";
import { defaultLocale } from "/src/i18n/index.js";
const messages = Object.assign(languages);

// import view from './directives/view' // eslint-disable-line
import reveal from "./directives/reveal"; // eslint-disable-line
import { resizeEnd } from "src/utils";
import "src/filters";

// Plugins
import Vue2TouchEvents from "vue2-touch-events";
import VueGtm from "vue-gtm";
import VueMeta from "vue-meta";
import VueBrowserUpdate from "@sum.cumo/vue-browserupdate";

import * as FullStory from "@fullstory/browser";

Vue.use(VueBrowserUpdate, {
    options: {
        // Your browser update options
        required: {
            e: -1,
            f: 90,
            o: -1,
            s: 13,
            c: 92
        },
        insecure: true,
        unsupported: true
    }
});

// Add window resizeEnd event
resizeEnd();

// Vars
Vue.config.productionTip = false;
const isProd = process.env.NODE_ENV === "production";

var i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: "fr",
    messages
});

// Meta descriptions
Vue.use(VueMeta, {});

// GTM
if (isProd && process.env.VUE_APP_GTM) {
    Vue.use(VueGtm, {
        id: process.env.VUE_APP_GTM,
        queryParams: {
            gtm_auth: process.env.VUE_APP_GTM_AUTH,
            gtm_cookies_win: "x"
        },
        defer: true,
        enabled: true,
        debug: false,
        vueRouter: router,
        loadScript: true
        // ignoredViews: [''],
        // trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
    });
}

// Vue touch
Vue.use(Vue2TouchEvents, {});

// Full Story
if (process.env.VUE_APP_FULLSTORY) {
    FullStory.init({ orgId: `${process.env.VUE_APP_FULLSTORY}` });
    Vue.prototype.$FullStory = FullStory;
}

// Initial load
store.dispatch("global/initLoad");

// Vue instance
new Vue({
    el: "#vue",
    router,
    store,
    i18n,
    render: h => h(App),
    mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount("#app");
